const env = process.env.RAZZLE_NODE_ENV || process.env.NODE_ENV || 'development'
export const release = `${process.env.EEVEE_ID || 'eevee'}:${process.env.RAZZLE_RELEASE}`

export const isServer = typeof window === 'undefined'
export const isDev = env === 'development'
export const isProd = env === 'production'
export const isCi = process.env.CI && process.env.CI !== 'false'

const defaultCacheControl = 'private, no-store'
const defaultSurrogateControl = 'no-store'
export const environment = env

export const cacheControl = process.env.CACHE_CONTROL || defaultCacheControl
export const assetsCacheControl = process.env.ASSETS_CACHE_CONTROL || defaultCacheControl
export const iconsCacheControl = process.env.ICONS_CACHE_CONTROL || defaultCacheControl
export const statusCacheControl = process.env.STATUS_CACHE_CONTROL || defaultCacheControl

export const surrogateControl = process.env.SURROGATE_CONTROL || defaultSurrogateControl
export const assetsSurrogateControl =
  process.env.ASSETS_SURROGATE_CONTROL || defaultSurrogateControl
export const iconsSurrogateControl = process.env.ICONS_SURROGATE_CONTROL || defaultSurrogateControl
export const statusSurrogateControl =
  process.env.STATUS_SURROGATE_CONTROL || defaultSurrogateControl

export const surrogateKey = process.env.SURROGATE_KEY || 'content'
export const assetsSurrogateKey = process.env.ASSETS_SURROGATE_KEY || 'assets'
export const iconsSurrogateKey = process.env.ICONS_SURROGATE_KEY || 'assets icons'

export const elasticSearchHost = process.env.ELASTIC_SEARCH_HOST
export const isElasticSearchEnabled = elasticSearchHost && elasticSearchHost.length > 0

export const forceHydration =
  process.env.RAZZLE_FORCE_HYDRATION === 'true'
    ? true
    : process.env.RAZZLE_FORCE_HYDRATION === 'false'
    ? false
    : isDev

export const debugHydration = process.env.RAZZLE_DEBUG_HYDRATION === 'true'

export const indexPages = process.env.RAZZLE_INDEX_PAGES !== 'false'

export default env
